export default __webpack_public_path__ + "static/media/clinic_default.f41c97ba.png";